<template>
  <section class="menus-detail-container">
    <base-header
      v-bind="headers"
      @handleBack="handleClickBack"
    />
    <base-form
      ref="form"
      v-bind="form"
    >
      <template #statusList="scope">
        <div class="apis-list-wrap">
          <div class="status-list">
            <template v-for="(item, index) in scope.form[scope.item.prop]">
              <span class="status-item" :key="index">
                <span class="">
                  <span class="text title">{{checkList.filter(x => x.value === item.type).length == 1 ? checkList.filter(x => x.value === item.type)[0].label : ''}}</span>
                  <span class="text">{{item.createUser ? item.createUser : '暂无'}}</span>
                  <span class="text">{{item.createTime}}</span>
                  <span>
                    <el-button type="default" size="small" width="82px" @click="handleShowDetailDialog(item)">
                      详情查看
                    </el-button>
                  </span>
                </span>
                <span class="status-icon" v-if="index !== scope.form[scope.item.prop].length - 1"><i class="el-icon-right" @click="()=>handleDeleteFile()"></i></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <template #attachment="scope">
        <div class="apis-list-wrap">
          <span>{{scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId ? scope.form[scope.item.prop].fileName : '暂无'}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-button v-if="scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId" type="primary" size="small" width="82px" @click="handleDownload(scope.form[scope.item.prop])">
            点击下载
          </el-button>
        </div>
      </template>
      <template #fileList="scope">
        <div class="apis-list-wrap">
          <el-button type="primary" :disabled="scope.form[scope.item.prop].length > 0 ? true : false" size="small" width="82px" @click="handleShowUploadDialog">
            选择文件
          </el-button>
          <div class="apis-list">
            <template v-for="(item, index) in scope.form[scope.item.prop]">
              <span class="api-item jee-hover-border-important jee-hover-color" :key="index">
                <span>{{item.fileName}}</span>
                <i class="el-icon-close" @click="()=>handleDeleteFile()"></i>
              </span>
            </template>
          </div>
        </div>
      </template>
    </base-form>
    <form-dialog
      title="详情"
      ref="detailDialog"
      :loading="detailFormLoading"
      :form="detailForm"
      :formItems="detailFormItems"
      :buttons="detailButtons"
    >
      <template #attachment="scope">
        <div class="apis-list-wrap">
          <span>{{scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId ? scope.form[scope.item.prop].fileName : '暂无'}}&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-button v-if="scope.form[scope.item.prop] && scope.form[scope.item.prop].fileId" type="primary" size="small" width="82px" @click="handleDownload(scope.form[scope.item.prop])">
            点击下载
          </el-button>
        </div>
      </template>
    </form-dialog>
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseForm from '@/components/mixins/baseForm'
import formDialog from '@/components/mixins/formDialog'
import msgDialog from '@/components/mixins/msgDialog'

export default {
  name: 'extcontentCheck',
  mixins: [baseHeader, baseForm, msgDialog, formDialog],
  data () {
    const checkList = [
      {
        label: '存为草稿',
        value: 'SAVE_DRAFT'
      },
      {
        label: '投递',
        value: 'POST'
      },
      {
        label: '撤稿',
        value: 'CANCEL'
      },
      {
        label: '取消撤稿',
        value: 'CANCEL_CANCEL'
      },
      {
        label: '删除',
        value: 'DELETE'
      },
      {
        label: '转发给编辑',
        value: 'FORWARD_EDITOR'
      },
      {
        label: '转发给专家',
        value: 'FORWARD_PROFESSOR'
      },
      {
        label: '同意撤稿',
        value: 'AGREE_CANCEL'
      },
      {
        label: '拒绝撤稿',
        value: 'REFUSED_CANCEL'
      },
      {
        label: '录用',
        value: 'OFFER'
      },
      {
        label: '返修',
        value: 'REFUND'
      },
      {
        label: '编辑退稿',
        value: 'CANCELED'
      },
      {
        label: '专家意见: 录用',
        value: 'AGREE'
      },
      {
        label: '专家意见: 返修',
        value: 'DISAGREE'
      },
      {
        label: '专家意见: 退稿',
        value: 'PROFESSOR_CANCEL'
      }
    ]
    return {
      checkList,
      detailFormLoading: false,
      detailForm: {
        'attachment': {},
        'remark': ''
      },
      detailButtons: [],
      detailFormItems: [
        {
          prop: 'remark',
          type: 'text',
          label: '内容'
        },
        {
          prop: 'attachment',
          type: 'slot',
          label: '附件'
        }
      ],
      form: {
        api: 'fetchExtcontentProfessorDetail',
        params: {
          id: ''
        },
        form: {
          id: '',
          checkType: 1,
          fileList: [],
          remark: '',
          remarkText: '',
          statusList: [],
          attachment: {}
        },
        formItems: [
          {
            prop: 'updateTime',
            label: '来稿时间：',
            type: 'text'
          },
          {
            prop: 'attachment',
            label: '稿件查看：',
            type: 'slot'
          },
          // {
          //   prop: 'createUser',
          //   label: '投稿人：',
          //   type: 'text'
          // },
          {
            prop: 'remark',
            label: '备注说明：',
            type: 'text'
          },
          {
            prop: 'status',
            label: '状态：',
            type: 'text',
            options: [
              {
                label: '草稿',
                value: 'DRAFT'
              },
              {
                label: '待审核',
                value: 'UNCHECK'
              },
              {
                label: '审核中',
                value: 'CHECKING'
              },
              {
                label: '已撤稿',
                value: 'CANCEL'
              },
              {
                label: '已返修',
                value: 'REFUND'
              },
              {
                label: '已录用',
                value: 'SUCCESS'
              },
              {
                label: '被退稿',
                value: 'CANCELED'
              },
              {
                label: '系统退稿',
                value: 'SYSTEM_CANCELED'
              },
              {
                label: '申请撤稿',
                value: 'CHECK_CANCEL'
              },
              {
                label: '专家审核中',
                value: 'CHECKING_PROFESSOR'
              }
            ]
          },
          {
            prop: 'statusList',
            label: '历史记录：',
            type: 'slot'
          }
        ],
        rules: {},
        submitBtns: []
      },
      headers: {
        buttons: [
          {
            type: 'Back',
            text: '返回',
            icon: 'fanhui'
          }
        ],
        title: '',
        showAlertIcon: false,
        content: ''
      }
    }
  },
  inject: ['removeTab'],
  methods: {
    fetchFormCallBack (res) {
      if (res.code === 200) {
        res.data.hidden = !res.data.hidden
        this.$set(this.form, 'form', {
          id: res.data.id,
          checkType: 1,
          remark: res.data.remark,
          remarkText: '',
          fileList: [],
          statusList: res.data.details,
          attachment: {
            fileName: res.data.attachmentName,
            fileId: res.data.attachment
          },
          updateTime: res.data.updateTime,
          createUser: res.data.createUser,
          status: res.data.status
        })
      }
    },
    handleShowUploadDialog () {
      this.$refs.uploadDialog.showDialog()
    },
    handleShowDetailDialog (data) {
      this.detailForm = {
        attachment: {
          fileName: data.attachmentName,
          fileId: data.attachment
        },
        remark: data.remark
      }
      let arr = ['POST', 'FORWARD_EDITOR', 'FORWARD_PROFESSOR', 'CANCEL']
      let arr2 = ['OFFER', 'REFUND', 'CANCELED', 'AGREE', 'DISAGREE', 'PROFESSOR_CANCEL']
      if (arr.indexOf(data.type) !== -1) {
        this.detailFormItems[0].label = '备注说明'
      } else if (arr2.indexOf(data.type) !== -1) {
        this.detailFormItems[0].label = '审稿意见'
      } else {
        this.detailFormItems[0].label = '内容'
      }
      this.$refs.detailDialog.showDialog()
    },
    handleDownload (data, btn) {
      console.log(data)
      // 下载
      var ids = [data.fileId]
      this.$request.resourceSpaceDatasDownload({ ids: ids }).then(res => {
        this.$exportClick(res, data.fileName)
      })
    },
    handleClickBack () {
      this.removeTab(this.$route.fullPath)
      this.$router.replace({ name: 'extcontentProfessorListIndex' })
    }
  },
  mounted () {
    const { id } = this.$route.query
    this.form.params.id = id
    this.fetchFormApi()
  },
  activated () {
    const { id } = this.$route.query
    if (id) {
      this.form.params.id = id
      this.fetchFormApi()
    }
  }
}
</script>
<style lang="scss" scoped>
.menus-detail-container{
  .apis-list{
    color: #666666;
    display: flex;
    flex-direction: column;
    width: 414px;
    .api-item{
      font-size: 14px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      line-height: 22px;
      padding: 10px 30px 10px 10px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      margin-top: 10px;
      position: relative;
      span {
        word-break: break-all;
      }
      span:last-of-type{
        flex: 1;
      }
      i{
        cursor: pointer;
        position: absolute;
        right: 10px;
      }
    }
  }
  .status-list {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    border: solid 1px #e5e5e5;
    .status-item {
      display: flex;
      align-items: center;
      padding: 20px;
      box-sizing: border-box;
      span {
        display: block;
        text-align: left;
      }
      .text {
        line-height: 26px;
        color:#5f5d5d;
      }
      .title {
        color: #000;
      }
    }
    .status-icon {
      margin-left: 20px;
    }
  }
  .tip-header {
    height: 40px;
    background:#f2fbfc;
    border:1px solid #1fc6df;
    border-radius:4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-right: 40px;
    margin-bottom: 40px;
    box-sizing: border-box;
    .title {
      font-size:14px;
      color:#000000;
    }
    .button {

    }
  }
}
</style>
